import Button from "@components/global/new/Button/Button";
import Title from "@components/global/new/Title/Title";
import { MinerChatMessage } from "@services/http/miners/dto";
import { useIntl } from "react-intl";
import styles from "./AdminNotesForm.module.scss";
import { IAdminNotesFormProps } from "./AdminNotesForm.props";
import MinerChatMessageItem from "./MinerChatMessageItem";
import useAdminNotesControl from "./useAdminNotesControl";
import Field from "@components/global/new/Field/Field";
import Icon from "@components/global/new/Icon/Icon";

import { Drawer } from "antd";
import { useEffect, useLayoutEffect, useRef } from "react";

import origChat from "@assets/redesign/icons/chat.svg";
import wlpChat from "@components/WLP202603/assets/redesign/icons/chat.svg";
import { WLP202603 } from "../../../../../../config";

const chat = WLP202603 ? wlpChat : origChat;


interface MessageContainerProps {
  isAdmin: boolean;
  messages: MinerChatMessage[];
}

function Messages({ isAdmin, messages }: MessageContainerProps): JSX.Element {

  const { formatMessage } = useIntl();

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const autoScrollRef = useRef(true);

  useLayoutEffect(() => {
    if (autoScrollRef.current && scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      container.scrollTop = container.scrollHeight;
    }
  }, [messages]);

  // useLayoutEffect(() => {
  //   if (autoScrollRef.current && scrollContainerRef.current) {
  //     scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
  //   }
  // }, [messages]);

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 50;
    autoScrollRef.current = isAtBottom;
  };

  if (messages.length === 0) {
    return (
      <p className={styles.empty}>
        {formatMessage({ id: "machines.more.settings.messages.empty" })}
      </p>
    );
  }

  return (
    <div className={styles.messages_block}
      ref={scrollContainerRef}
      onScroll={handleScroll}>
      {messages.map((message) => (
        <MinerChatMessageItem
          key={message.Id}
          isAdmin={isAdmin}
          message={message}
        />
      ))}
    </div>
  );
}

export default function AdminNotesForm({ minerId }: IAdminNotesFormProps) {
  const { formatMessage } = useIntl();
  const control = useAdminNotesControl({ minerId });

  return (
    <>
      <Drawer
        title={formatMessage({
          id: "machines.more.settings.messages.title_admin",
        })}
        onClose={control.onToggleDrawwer.bind({}, false)}
        open={control.isOpen}
      >
        <form className={styles.admin_notes} onSubmit={control.onSubmit} ref={control.formRef}>
          <div className={styles.notes_wrapper}>
            <Messages isAdmin={control.isAdmin} messages={control.messages} />
            <div
              id={`lastmessage-${minerId}`}
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "transparent",
              }}
            ></div>
          </div>
          <div className={styles.message}>
            <Field
              type='text'
              placeholder={formatMessage({
                id: "machines.more.settings.messages.placeholder",
              })}
              id='admin_note'
              reset={control.reset}
              onKeyDown={control.onInputKeyDown}
            />
            <Button type='submit' loading={control.isSubmitting} white>
              {formatMessage({ id: "machines.more.settings.messages.btn" })}
            </Button>
          </div>
        </form>
      </Drawer>
      <div
        className={styles.wrapper}
        onClick={control.onToggleDrawwer.bind({}, true)}
      >
        <Icon className={styles.icon} src={chat} noHover />
        {/*<span className={styles.text}>
          {formatMessage({ id: "machines.more.settings.messages.title_admin" })}
        </span>*/}
      </div>
    </>
  );
}
